import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import CalculatorAnchorLink from '../../../components/common/CalculatorAnchorLink';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { MarketingPlusFeatureTable } from './MarketingPlusFeatureTable';
import { MarketingPlusMerchCards } from './MarketingPlusMerchCards';
import { SCREENS } from '../../constants/tracking/Screens';
import PhoneSupportMiddle from '../../components/phone-support/PhoneSupportMiddle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MARKETING_PLUS_API_NAMES = [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL, Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE];
export const MarketingPlusPage = () => {
  const screen = SCREENS.MARKETING_PLUS;
  useDocumentTitle('marketing-plus');
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "MARKETING_PLUS_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "MARKETING_PLUS",
      apiNames: MARKETING_PLUS_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.marketingPlus.pageTitle"
        })
      }), /*#__PURE__*/_jsxs(PageSubTitle, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.marketingPlus.description"
        }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {
          defaultProductApiName: Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL
        })]
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(MarketingPlusMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "marketing-plus"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(MarketingPlusFeatureTable, {})
    }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
      phoneSourceId: "marketingplus-middle",
      screen: screen,
      apiName: Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "marketing-plus"
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "marketingplus-footer",
      screen: screen,
      apiName: Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL
    })]
  });
};